import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import { Card, CardHeader, Box, Typography } from '@mui/material';

export const DonutComponent = ({ title, subheader, chartData = [], chartColors = [], height = 300 }) => {
  const labels = useMemo(() => chartData.map((item) => item.label), [chartData]);
  const series = useMemo(() => chartData.map((item) => Number(item.value || 0)), [chartData]);
  const total = useMemo(() => series.reduce((sum, value) => sum + Number(value || 0), 0), [series]);

  const options = useMemo(
    () => ({
      chart: {
        type: 'donut',
        toolbar: {
          show: false,
        },
      },
      labels,
      colors: chartColors,
      legend: {
        position: 'bottom',
        fontSize: '12px',
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => `${Number(val).toFixed(1)}%`,
      },
      stroke: {
        width: 1,
        colors: ['#fff'],
      },
      plotOptions: {
        pie: {
          donut: {
            size: '62%',
            labels: {
              show: true,
              total: {
                show: true,
                showAlways: true,
                label: 'Total',
                formatter: () => Number(total).toFixed(0),
              },
              value: {
                formatter: (val) => Number(val).toFixed(0),
              },
            },
          },
        },
      },
      tooltip: {
        y: {
          formatter: (val) => Number(val).toFixed(0),
        },
      },
      theme: {
        monochrome: {
          enabled: false,
        },
      },
    }),
    [labels, chartColors, total]
  );

  const hasData = series.length > 0 && series.some((value) => value > 0);

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ px: 2, pb: 2 }}>
        {!hasData ? (
          <Box
            sx={{
              height,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="text.secondary">
              표시할 데이터가 없습니다.
            </Typography>
          </Box>
        ) : (
          <Chart options={options} series={series} type="donut" height={height} />
        )}
      </Box>
    </Card>
  );
};
